import * as React from 'react';
import Stepper from '@mui/joy/Stepper';
import Step from '@mui/joy/Step';
import StepIndicator from '@mui/joy/StepIndicator';
import {IconButton, StepButton} from "@mui/material";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";

export default function HorizontalLinearStepper({steps, activeStep, setActiveStep, handleLeft, handleRight}) {

    return (
        <div style={{display: "flex", justifyContent: "space-around", alignItems: "center", backgroundColor: "#fff", paddingBottom: "25px", paddingTop: "10px"}}>
            <IconButton
                onClick={handleLeft}
                color='primary' sx={{border: "3px solid #64B5F6"}} size="small"><KeyboardArrowLeft /></IconButton>
            <Stepper sx={{width: "60%"}}>
                {steps.map((step, index) => (
                    <Step key={index}
                          orientation="vertical"
                          indicator={
                              <StepIndicator
                                  sx={{
                                      border: '3px solid #64B5F6',
                                      backgroundColor: activeStep === index ? '#42A5F5' : '#BBDEFB'
                                  }}
                                  variant={activeStep === index ? 'solid' : 'soft'}
                              >
                                  {/*{activeStep === index && <Check />}*/}
                              </StepIndicator>
                          }
                          sx={{
                              '&::after': {
                                  ...({bgcolor: 'primary.solidBg'}),
                              },
                          }}
                    >
                        {/*<StepLabel>{step.label}</StepLabel>*/}
                        <StepButton onClick={() => {
                            setActiveStep(index);
                        }} sx={{color: "#1976D2"}}>{index === activeStep? <strong>{step.label}</strong> : step.label}</StepButton>
                    </Step>
                ))}
            </Stepper>
            <IconButton
                onClick={handleRight}
                color='primary' sx={{border: "3px solid #64B5F6"}}
                size="small"><KeyboardArrowRight /></IconButton>
        </div>
    );
}